import { render, staticRenderFns } from "./InspectionReasonForm.vue?vue&type=template&id=5fe4a7e9&"
import script from "./InspectionReasonForm.vue?vue&type=script&lang=js&"
export * from "./InspectionReasonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports